module.exports = __webpack_public_path__ + "static/assets/matthew-smith-Rfflri94rs8-unsplash.1af5357f.jpg";